import React, { Component, lazy } from 'react';
import { connect } from 'react-redux';
import NavDropdown from 'react-bootstrap/NavDropdown';
import Button from 'react-bootstrap/Button';
import Dropdown from 'react-bootstrap/Dropdown';
import { Prompt, Link, withRouter } from 'react-router-dom';
import {
    IoMdApps,
} from 'react-icons/io';
import {
    FaPlay,
    FaExternalLinkAlt,
    FaAndroid,
    FaApple,
} from 'react-icons/fa';


export default class AppsDrawer extends Component {
    constructor(props) {
        super(props);

        this.state = {

        };
    }

    render() {
        return (
            <Dropdown className="apps-drawer">
                <Dropdown.Toggle>
                    <IoMdApps color={this.props.variant === 'dark' ? '#fff' : '#000'} size={28} />
                </Dropdown.Toggle>

                <Dropdown.Menu align="end">
                    <Dropdown.Header>AppBlocks Cloud</Dropdown.Header>
                    <NavDropdown.Item href="/devices" target="_blank">
                        <FaExternalLinkAlt className="dropdown-link-icon" />
                        Devices
                    </NavDropdown.Item>
                    <NavDropdown.Item href="/groups" target="_blank">
                        <FaExternalLinkAlt className="dropdown-link-icon" />
                        Device Groups
                    </NavDropdown.Item>
                    <NavDropdown.Item href="/workflows" target="_blank">
                        <FaExternalLinkAlt className="dropdown-link-icon" />
                        Workflows
                    </NavDropdown.Item>
                    <NavDropdown.Item href="/events" target="_blank">
                        <FaExternalLinkAlt className="dropdown-link-icon" />
                        Events
                    </NavDropdown.Item>
                    <Dropdown.Header>Utilities</Dropdown.Header>
                    <NavDropdown.Item href="https://apps.tibbo.com/luis/" target="_blank">
                        <FaExternalLinkAlt className="dropdown-link-icon" />
                        L.U.I.S.
                    </NavDropdown.Item>
                    <NavDropdown.Item href="https://apps.tibbo.com/BLEFirmwareUpdater/" target="_blank">
                        <FaExternalLinkAlt className="dropdown-link-icon" />
                        BLE Firmware Updater
                    </NavDropdown.Item>
                    <NavDropdown.Item href="https://apps.tibbo.com/tc_generator/" target="_blank">
                        <FaExternalLinkAlt className="dropdown-link-icon" />
                        TCU File Generator
                    </NavDropdown.Item>
                    <NavDropdown.Item href="https://apps.tibbo.com/bin_merger/" target="_blank">
                        <FaExternalLinkAlt className="dropdown-link-icon" />
                        BIN Merger
                    </NavDropdown.Item>
                    <Dropdown.Divider />

                    <Dropdown.Header>Links</Dropdown.Header>
                    <NavDropdown.Item href="https://apps.apple.com/us/app/luis/id1450127637" target="_blank">
                        <FaApple className="dropdown-link-icon" />
                        LUIS iOS
                    </NavDropdown.Item>
                    <NavDropdown.Item href="https://play.google.com/store/apps/details?id=com.tibbo.tibboble" target="_blank">
                        <FaAndroid className="dropdown-link-icon" />
                        LUIS Android
                    </NavDropdown.Item>
                    <NavDropdown.Item href="https://appblocks.canny.io/feedback" target="_blank">
                        <FaExternalLinkAlt className="dropdown-link-icon" />
                        Feedback
                    </NavDropdown.Item>
                </Dropdown.Menu>
            </Dropdown>
        );
    }
}
